const initialState = {
  orders: { data: [] },
  dashboard_chart: [],
  today_order_count: {},
  today_orders: { data: [] },
};

export const order_reducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_ORDERS":
      return {
        ...state,
        orders: action.payload,
      };
    case "GET_TODAY_ORDERS":
      return {
        ...state,
        today_orders: action.payload,
      };
    default:
      return state;
  }
};
